import { Map } from 'immutable';
import {
  SET_ANONYMOUS,
  LOG_IN,
  LOG_OUT
} from './actions';

export const initialState = new Map({
  isAuthorized: false,
  isAuthenticated: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ANONYMOUS: {
      return state
        .set('isAuthorized', true)
        .set('isAuthenticated', false);
    }
    case LOG_IN: {
      return state
        .set('isAuthorized', true)
        .set('isAuthenticated', true);
    }
    case LOG_OUT: {
      return state
        .set('isAuthorized', false)
        .set('isAuthenticated', false);
    }
    default: {
      return state;
    }
  }
};
